export default {
  API_URL: "http://localhost:9090",
  APP_PATH: "",
  JWT_TOKEN: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE2MDE4MDExMDgsImV4cCI6MTYwMjY2NTEwOCwidXNlcm5hbWUiOiJuaWNvbGFzIn0.srWzl_yx1n9KHvCNNeGY_TG46QSIbZCgYKnYwHJQsC4X03bsU5AvAlARG1xysoKo-LqLUwEAi28HcEKxW85ZKP8oyzqdO75i3v8TieHhDjYtbqirmEquckShfFsIHV7OOcdR8mCnPF12r_cuVQky9vwr91lkKON4A5hOB00wBmMnEi15-wM5MMVtBr6uVxtUlQWHeMTQWuOIYQ72_eI_Vcq6ntb6LsMZr0tOGakeLHre2lA03iSqFnhbqJyXA5OW4RXiC90FQOhC_nkxIqU-dlk5fetuYQczg_u3_1to5jYA3jK8KgM-wlW-7wqCUavIHgroZLboj3OJknm3nWkz79S7g6OBAFTVbQX58rrYzE9TC4gAUrjjfbEzbDdVTOKNUfDDZxXf2lZ-TwQ3Sg0HWxuRTVLL8AOFOeo9U_AE_SOK4zoAWeNYbwBk1BQ_gIwpJ_vsD0xvewKNJRhKK1oaoeku6yobsu5FQfpDE45j1rTjnTL_4EK-PmMcTO5bB7p5TgeOU8Cg7XGiMB9bDSGR2EvR_w5zk_Ed9Dpid1hJE_KDX3gINAhooWOHFh2Zwv9thy1WTQyfZfrc9lMxa88vzT0nVlvOiSbd_a4SKCFyxU2UdK11QTIkw_UUmKuhYwu_0RZ2j1dtKcnaxqb0r0wuLoC64IsdsGeXxj3RrCKJc6o",
  MAX_DAYS: 14,
  SHOP_ADDRESS: 'Route des Pistes',
  SHOP_CITY: 'Villard Reculas',
  SHOP_EMAIL: 'contact@ptitpingouin.com',
  SHOP_NAME: 'Ptit Pingouin',
  SHOP_PHONE: '04 76 80 45 58',
  SHOP_ZIPCODE: '38114',
  TVA_RATE: 0.2
}
